import { render } from "./carruselComponente-3.vue?vue&type=template&id=73267a7e&scoped=true"
import script from "./carruselComponente-3.vue?vue&type=script&lang=js"
export * from "./carruselComponente-3.vue?vue&type=script&lang=js"

import "./carruselComponente-3.vue?vue&type=style&index=0&id=73267a7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73267a7e"]])

export default __exports__